const LIST_MARKER_PATTERN = /^\s*(?:[-*+]|\d+\.)\s+/;
const HEADING_MARKER_PATTERN = /(^|[\s"'“‘([])#{1,6}\s+/g;
const LINK_PATTERN = /\[([^\]]+)\]\([^)]*\)/g;
const CODE_SPAN_PATTERN = /`([^`]+)`/g;
const STRIKETHROUGH_PATTERN = /~~(\S(?:.*?\S)?)~~/g;
const STRONG_PATTERN = /\*\*(\S(?:.*?\S)?)\*\*/g;
const EMPHASIS_PATTERN = /(^|[\s"'“‘([])[*_]{1,2}(\S(?:.*?\S)?)[*_]{1,2}(?=[\s"'”’).,;:!?]|$)/g;

/**
 * Remove inline markdown syntax from a single line of text so it can be rendered
 * as plain text. Intended for LLM-generated strings that are displayed verbatim.
 */
export function stripMarkdown(text: string): string {
  return text
    .replace(LIST_MARKER_PATTERN, '')
    .replace(HEADING_MARKER_PATTERN, '$1')
    .replace(LINK_PATTERN, '$1')
    .replace(CODE_SPAN_PATTERN, '$1')
    .replace(STRIKETHROUGH_PATTERN, '$1')
    .replace(STRONG_PATTERN, '$1')
    .replace(EMPHASIS_PATTERN, '$1$2')
    .trim();
}
